export const MENU_CODES = Object.freeze({
  HOME: 'home',
  STUDENT_INFO: 'studentInfo',
  COACH_INFO: 'coachInfo',
  SCHOOL_INFO: 'schoolInfo',
  QUOTA_RECORDS: 'quotaRecords',
  SYSTEM_MANAGE: 'systemManage'
})

const SCHOOL_DEFAULT_CODES = Object.freeze([
  MENU_CODES.HOME,
  MENU_CODES.STUDENT_INFO,
  MENU_CODES.COACH_INFO,
  MENU_CODES.SCHOOL_INFO,
  MENU_CODES.QUOTA_RECORDS
])

const ADMIN_CODES = Object.freeze([...SCHOOL_DEFAULT_CODES, MENU_CODES.SYSTEM_MANAGE])

export function effectiveMenuCodes (userinfo) {
  if (Array.isArray(userinfo.menuCodes)) return userinfo.menuCodes
  return userinfo.username === 'admin' ? ADMIN_CODES : SCHOOL_DEFAULT_CODES
}

export function canAccessMenu (userinfo, menuCode) {
  return effectiveMenuCodes(userinfo).includes(menuCode)
}

export function firstAccessiblePath (userinfo) {
  const codes = effectiveMenuCodes(userinfo)
  const orderedRoutes = [
    [MENU_CODES.HOME, '/'],
    [MENU_CODES.STUDENT_INFO, '/school/studentList'],
    [MENU_CODES.COACH_INFO, '/school/coachList'],
    [MENU_CODES.SCHOOL_INFO, '/school/schoolList'],
    [MENU_CODES.QUOTA_RECORDS, '/school/schoolNumsAddRecord'],
    [MENU_CODES.SYSTEM_MANAGE, '/systemManage/schoolManageList']
  ]
  const matched = orderedRoutes.find(([code]) => codes.includes(code))
  return matched ? matched[1] : '/login'
}
